import React from 'react';
import * as PropTypes from 'prop-types';

// FullStory search (AP-21996): attribute equals the visible text.
// Placeholders like 'Pending' stay untagged.
const createTrackedNumber = (attribute, displayName) => {
    const TrackedNumber = ({value, fallback}) => {
        if (value === null || value === undefined) return fallback;

        const text = String(value).trim();
        if (!text) return text;

        return <span {...{[attribute]: text}}>{text}</span>;
    };

    TrackedNumber.displayName = displayName;

    TrackedNumber.propTypes = {
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        fallback: PropTypes.node,
    };

    TrackedNumber.defaultProps = {
        fallback: '',
    };

    return TrackedNumber;
};

export const RefNumber = createTrackedNumber('data-reference-number', 'RefNumber');
export const PoNumber = createTrackedNumber('data-po-number', 'PoNumber');
export const RgaNumber = createTrackedNumber('data-rga-number', 'RgaNumber');
